import React, { Component } from 'react';
import Modal from "../../../components/Modal/";

import './add-students-flow.less';
import trackEvent from "../eventTracking";

//////////////////////////////////////////////////////////////////
const FILE_INPUT = 'fileInput'  // Used at end point
//////////////////////////////////////////////////////////////////

class ImportSpreadsheetModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadedFileName: '',
      formData: new FormData()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && !(prevProps.open)) {
      this.setState({
        uploadedFileName: '',
        formData: new FormData()
      })
    }
  }

  /////////////////////////////////
  // Helper functions
  /////////////////////////////////

  handleOpenFileUploader = () => {
    this.fileUploader.click();
  }

  handleSelectFile = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const file = e.target.files[0];
    let newFormData = new FormData();
    newFormData.append(FILE_INPUT, file);

    this.setState({
      uploadedFileName: file.name,
      formData: newFormData
    });

    this.fileUploader.value = '';  // Reset file stored in input. Without this, if user selects same file after re-opening the modal, "onChange" wouldn't get us here
  }

  handleImport = () => {
    trackEvent('import names', 'completed', true, 'spreadsheet');

    this.props.handleUploadFromSpreadsheeet(this.state.formData);
  }

  /////////////////////////////////

  render() {
    return (
      <Modal className='spreadsheet-modal' open={this.props.open} onClose={this.props.closeImportSpreadsheetModal}>
        <h3>Import from spreadsheet</h3>

        <div className="notes">
            <p>Use first column for {this.props.yourX.singular} names like below:</p>
            <img src="/themes/sky/i/progress-tracker/img-spreadsheet-sample.png" />
            <p>Accepted file formats are Excel (.xls and .xlsx) and CSV (.csv)</p>
        </div>

        <div className={(this.state.uploadedFileName === '') ? 'fileNameOff' : 'fileNameOn'}>{this.state.uploadedFileName + ' is selected'}</div>

        <div className="bottom-buttons">
          <button
            className="btn btn-secondary"
            onClick={this.props.closeImportSpreadsheetModal}
          >
            Cancel
          </button>

          <button
            className={"btn btn-primary " + (this.state.uploadedFileName === '' ? 'action-show' : 'action-hide')}
            onClick={() => this.handleOpenFileUploader()}
          >
            Select file<span className="hide-if-mobile"> from your computer</span>
            <input
              type="file"
              accept="text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              style={{display: "none"}}
              ref={(ref) => this.fileUploader = ref}
              onChange={(e) => this.handleSelectFile(e)}
            />
          </button>

          <button
            className={"btn btn-primary " + (this.state.uploadedFileName === '' ? 'action-hide' : 'action-show')}
            onClick={()=>this.handleImport()}
          >
            Import names from this file
          </button>
        </div>
      </Modal>
    )
  }
}

export default ImportSpreadsheetModal;


// File upload references:
// https://stackoverflow.com/questions/37457128/react-open-file-browser-on-click-a-div
// https://www.taniarascia.com/how-to-upload-files-to-a-server-with-plain-javascript-and-php/
